export const COLUMN_WIDTH = {
  TxAddress: {
    MinWidth: 350,
  },
  TxHash: {
    MinWidth: 350,
  },
  CreatedBy: {
    MinWidth: 150,
  },
  CreatedDate: {
    MinWidth: 120,
  },
  LastModifiedBy: {
    MinWidth: 120,
  },
  LastModifiedDate: {
    MinWidth: 120,
  },
  ApprovalProgress: {
    MinWidth: 150,
  },

  // project scope
  MerchantId: {
    MaxWidth: 150,
  },

  // Wallet Transaction specific widths
  WalletTransaction: {
    // Core identifiers
    Id: {
      MinWidth: 80,
    },
    ExternalRecordId: {
      MinWidth: 160,
    },
    MerchantId: {
      MinWidth: 120,
    },
    MerchantOrderId: {
      MinWidth: 160,
    },

    // Request info
    RequestType: {
      MinWidth: 120,
    },
    CreatedDate: {
      MinWidth: 140,
    },
    LastModifiedDate: {
      MinWidth: 160,
    },
    CreatedBy: {
      MinWidth: 120,
    },
    CreatorType: {
      MinWidth: 120,
    },

    // From fields
    FromAbccAccountId: {
      MinWidth: 180,
    },
    FromClientId: {
      MinWidth: 140,
    },
    FromMemberId: {
      MinWidth: 140,
    },
    FromMerchantId: {
      MinWidth: 150,
    },
    FromAmount: {
      MinWidth: 120,
    },
    FromAssetName: {
      MinWidth: 150,
    },
    FromChainType: {
      MinWidth: 150,
    },
    FromCurrencyName: {
      MinWidth: 160,
    },
    FromDecimals: {
      MinWidth: 120,
    },

    // To fields
    ToAbccAccountId: {
      MinWidth: 170,
    },
    ToClientId: {
      MinWidth: 120,
    },
    ToMemberId: {
      MinWidth: 130,
    },
    ToMerchantId: {
      MinWidth: 140,
    },
    ToAmount: {
      MinWidth: 110,
    },
    ToAssetName: {
      MinWidth: 130,
    },
    ToChainType: {
      MinWidth: 140,
    },
    ToCurrencyName: {
      MinWidth: 150,
    },
    ToDecimals: {
      MinWidth: 110,
    },
    ToAddress: {
      MinWidth: 120,
    },
    ToWalletTag: {
      MinWidth: 130,
    },

    // Transaction details
    TxHash: {
      MinWidth: 160,
    },
    TxStatus: {
      MinWidth: 150,
    },
    BlockNumber: {
      MinWidth: 120,
    },
    BlockHash: {
      MinWidth: 120,
    },
    BlockTime: {
      MinWidth: 120,
    },

    // Standard merchant fields
    SenderMerchantId: {
      MinWidth: 160,
    },
    ReceiverMerchantId: {
      MinWidth: 160,
    },
    // Long descriptive fields
    LiquidityProviderMerchantId: {
      MinWidth: 110,
    },
    LiquidityProvider: {
      MinWidth: 120,
    },
    // Receiver fields
    ReceiverAssetName: {
      MinWidth: 180,
    },
    ReceiverAmount: {
      MinWidth: 150,
    },
    ReceiverChainType: {
      MinWidth: 180,
    },
    // Fiat fields
    ToFiatCurrency: {
      MinWidth: 140,
    },
    ToFiatAmount: {
      MinWidth: 130,
    },
    ToBankAccountDetails: {
      MinWidth: 200,
    },
    // Fee fields
    FeeAmount: {
      MinWidth: 130,
    },
    FeeAssetName: {
      MinWidth: 160,
    },
    FeeCurrencyName: {
      MinWidth: 160,
    },
    FeeDecimals: {
      MinWidth: 120,
    },
    // Email fields
    FromEmail: {
      MinWidth: 180,
    },
    ToEmail: {
      MinWidth: 160,
    },
    // Standard fields that need slight adjustment
    TransType: {
      MinWidth: 120,
    },
    AssetName: {
      MinWidth: 100,
    },
    // Status field
    Status: {
      MinWidth: 130,
    },
    // Exchange and amounts
    ExchangeRate: {
      MinWidth: 130,
    },
    EstimatedUsdtValue: {
      MinWidth: 170,
    },
    Sum: {
      MinWidth: 80,
    },
    // Additional fields
    Remarks: {
      MinWidth: 100,
    },
    RejectRemarks: {
      MinWidth: 130,
    },
    RefundOrderId: {
      MinWidth: 150,
    },
    RefNo: {
      MinWidth: 140,
    },
    PathId: {
      MinWidth: 100,
    },
    Topic: {
      MinWidth: 80,
    },
    PostBalance: {
      MinWidth: 120,
    },
    HotWalletAddress: {
      MinWidth: 170,
    },
    WalletTag: {
      MinWidth: 120,
    },
    ClientTag: {
      MinWidth: 120,
    },
    WalletManagerStatus: {
      MinWidth: 180,
    },
    // Legacy fields
    Amount: {
      MinWidth: 100,
    },
    Decimals: {
      MinWidth: 100,
    },
    ChainType: {
      MinWidth: 100,
    },
    CurrencyName: {
      MinWidth: 130,
    },
    // Audit fields
    CreatedAt: {
      MinWidth: 120,
    },
    UpdatedAt: {
      MinWidth: 120,
    },
    WalletTransactionId: {
      MinWidth: 80,
    },
  },

  // to be removed
  DistributorAgentId: {
    MinWidth: 200,
  },
  PartnerName: {
    MinWidth: 200,
  },
  ProgramName: {
    MinWidth: 200,
  },

  PlatformDailyReport: {
    ReportDate: {
      MinWidth: 150,
    },
    Chain: {
      MinWidth: 150,
    },
    AssetName: {
      MinWidth: 150,
    },
    OpeningBalance: {
      MinWidth: 150,
    },
    Deposit: {
      MinWidth: 150,
    },
    Withdrawal: {
      MinWidth: 150,
    },
    TransferIn: {
      MinWidth: 150,
    },
    TransferOut: {
      MinWidth: 150,
    },
    FiatWithdrawal: {
      MinWidth: 150,
    },
    SwapIn: {
      MinWidth: 150,
    },
    SwapOut: {
      MinWidth: 150,
    },
    PaymentIn: {
      MinWidth: 150,
    },
    PaymentOut: {
      MinWidth: 150,
    },
    MerchantPayment: {
      MinWidth: 150,
    },
    TotalIn: {
      MinWidth: 150,
    },
    TotalOut: {
      MinWidth: 150,
    },
    ClosingBalance: {
      MinWidth: 150,
    },
  },
  UserDailyReport: {
    ReportDate: {
      MinWidth: 150,
    },
    Email: {
      MinWidth: 150,
    },
    ClientId: {
      MinWidth: 150,
    },
    Chain: {
      MinWidth: 150,
    },
    AssetName: {
      MinWidth: 150,
    },
    OpeningBalance: {
      MinWidth: 150,
    },
    Deposit: {
      MinWidth: 150,
    },
    Withdrawal: {
      MinWidth: 150,
    },
    TransferIn: {
      MinWidth: 150,
    },
    TransferOut: {
      MinWidth: 150,
    },
    FiatWithdrawal: {
      MinWidth: 150,
    },
    SwapIn: {
      MinWidth: 150,
    },
    SwapOut: {
      MinWidth: 150,
    },
    PaymentIn: {
      MinWidth: 150,
    },
    PaymentOut: {
      MinWidth: 150,
    },
    MerchantPayment: {
      MinWidth: 150,
    },
    TotalIn: {
      MinWidth: 150,
    },
    TotalOut: {
      MinWidth: 150,
    },
    ClosingBalance: {
      MinWidth: 150,
    },
  },
};
